var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { routes } from "./constants";
var loggerName = 'MixpanelHelper';
/**
 * Checks if the Mixpanel API is blocked by making a HEAD request to the Mixpanel API endpoint.
 *
 * @async
 * @returns {Promise<boolean>} Returns a promise that resolves to:
 *                            - `true` if the Mixpanel API is blocked (request fails)
 *                            - `false` if the Mixpanel API is accessible (request succeeds)
 *
 * @example
 * const isBlocked = await checkIfMixpanelAPIIsBlocked();
 * if (isBlocked) {
 *   console.log('Mixpanel API is blocked');
 * }
 */
export var checkIfMixpanelAPIIsBlocked = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetch(routes.MIXPANEL_HEALTH_CHECK, { method: "HEAD", mode: "no-cors" })];
            case 1:
                _a.sent();
                return [2 /*return*/, false];
            case 2:
                error_1 = _a.sent();
                return [2 /*return*/, true];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Checks if the Mixpanel script is properly loaded and initialized in the browser.
 *
 * @returns {boolean} Returns false if all conditions are met:
 *                    - window.mixpanel exists and is an object
 *                    - window.getMixpanelInstance exists and is a function
 *                    - The instance is properly loaded (__loaded is true)
 *                    Returns true if any of these conditions fail, indicating the script is blocked
 */
export var checkIfMixpanelScriptIsBlocked = function () {
    var _a;
    if (!window.mixpanel || typeof (window.mixpanel) != "object")
        return true;
    if (!window.getMixpanelInstance || typeof (window.getMixpanelInstance) != "function")
        return true;
    return !((_a = window.getMixpanelInstance(window.trackerProperties.analyticsId)) === null || _a === void 0 ? void 0 : _a.__loaded);
};
/**
 * Checks if Mixpanel is blocked by the browser.
 *
 * This function determines whether the Mixpanel library is being blocked by browser extensions or privacy settings.
 * If not blocked, window.mixpanel is initalized with an empty array object with custom properties (_i, __SV, etc.)
 * set on js object propotype.
 * If Mixpanel is blocked, it is likely replaced with an empty array ([]) without any properties set on object prototype
 * by certain browser extensions or privacy settings.
 * It passes Array.isArray() but has length 0 because there are no actual array elements. So we need to check if there are
 * any properties set on the array object.
 *
 * @returns {boolean} `true` if Mixpanel is blocked by the browser, otherwise `false`.
 */
export var checkIfMixpanelIsBlockedByBrowser = function () {
    return Array.isArray(window.mixpanel) && window.mixpanel.length === 0 && Object.keys(window.mixpanel).length === 0;
    ;
};
